import { useCallback, useEffect } from 'react';

import { AccountsQueryString } from '@/interfaces/queryString';
import { loginAccounts } from '@/services/accounts';
import { clearTokens } from '@/services/token';

export const useHandleRedirectToAccounts = () => {
  const getHasParams = useCallback(() => {
    const params = Array.from(new URLSearchParams(window.location.search).keys());
    return {
      hasFirstAccess: params.includes(AccountsQueryString.firstAccess),
      hasLoginToken: params.includes(AccountsQueryString.loginToken),
      hasToken: params.includes(AccountsQueryString.token),
      hasRecoveryToken: params.includes(AccountsQueryString.recoveryToken)
    };
  }, []);

  useEffect(() => {
    const params = getHasParams();

    if (params.hasRecoveryToken) {
      clearTokens();
    }

    if ((params.hasFirstAccess || params.hasLoginToken) && !params.hasToken) {
      loginAccounts();
    }
  }, [getHasParams]);

  return getHasParams();
};
